import React, { Component } from 'react'
import { Dropdown, Menu, Checkbox, Button, Icon } from 'antd'
import { IExtraFields } from '../../../../utilities/LocalStorage'
import { IExtraFieldOption } from '.'

interface Props {
  extraFields: IExtraFields
  extraFieldOptions: IExtraFieldOption[]
  onChange: (fieldKey: string, fieldCheckedStatus: boolean, selectAll?: boolean) => void
}

export class ProductColumnDropdown extends Component<Props> {
  render() {
    return (
      <Dropdown
        className='gr-filter-item gr-filter-gutter'
        trigger={['click']}
        overlay={
          <Menu>
            <Menu.Item
              key='all'
              disabled
              style={{
                padding: 0,
                borderBottom: '1px solid #e8e8e8',
                marginLeft: '12px',
                marginRight: '12px',
              }}
            >
              <Checkbox
                checked={Object.values(this.props.extraFields).every((field) => field)}
                className='w-100'
                style={{ padding: '5px 0px' }}
                onChange={(e) => {
                  e.stopPropagation()
                  this.props.onChange('all', e.target.checked, e.target.checked)
                }}
              >
                <b>Select All</b>
              </Checkbox>
            </Menu.Item>
            {this.props.extraFieldOptions.map((option) => {
              return (
                <Menu.Item key={option.value} disabled style={{ padding: 0 }}>
                  <Checkbox
                    checked={this.props.extraFields[option.value]}
                    className='w-100'
                    style={{ padding: '5px 12px' }}
                    onChange={(e) => {
                      e.stopPropagation()
                      this.props.onChange(option.value, e.target.checked)
                    }}
                  >
                    {option.label}
                  </Checkbox>
                </Menu.Item>
              )
            })}
          </Menu>
        }
      >
        <Button
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '34px',
          }}
        >
          Table columns <Icon type='down' />
        </Button>
      </Dropdown>
    )
  }
}
